import {Injectable} from '@angular/core';

const viewSourceEnum = {
  native: 'native',
  salesForce: 'salesForce',
  extension: 'extension',
  other: 'other'
};

@Injectable({
  providedIn: 'root'
})
export class ViewSourceService {
  private source: string;

  public getViewSource() {
    return this.source;
  }

  public setViewSource(route) {
    const originSrc =
      route.queryParams.originSrc === viewSourceEnum.salesForce
        ? viewSourceEnum.salesForce
        : route.queryParams.originSrc === viewSourceEnum.extension
          ? viewSourceEnum.extension
          : viewSourceEnum.other;

    this.source =
      window.location === window.parent.location
        ? (this.source = viewSourceEnum.native)
        : (this.source = originSrc);

    return this.source;
  }
}
